import React from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import PropTypes from 'prop-types';

export default function SnackbarToast(props) {
  const { open, onClose } = props;
  return (
    <Snackbar
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={open}
      message="Some error occured"
      onClose={onClose}
      autoHideDuration={3000}
    />
  );
}

SnackbarToast.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
};
